import React from 'react'
import { Modal, Button } from 'talentneuron---ui-components-library'

export default function EditOneTimeFeedModal ({ intl, firstMsg, secondMsg, closeEditFeedModal }) {
  return (
    <Modal isModalOpen={true} override={false} backDrop={true} containerClassName="edit-oneTimeFeed-modal" isCloseOnOustsideClick={false} >
        <div className='modal-line-separator'>{intl.formatMessage({ id: firstMsg })}</div>
        <div className='modal-line-separator'> {intl.formatMessage({ id: secondMsg })}</div>
        <div className="button-row">
            <Button type={'secondary'} outline={true} className="pull-right" value={intl.formatMessage({ id: 'okay' })} onClick={() => closeEditFeedModal()} />
        </div>
    </Modal>
  )
}
